import React from 'react'
import { cx } from '../lib/cx'

type Props = React.HTMLAttributes<HTMLDivElement>

export function Card({ className, ...rest }: Props) {
  return (
    <div
      className={cx(
        'rounded-xl bg-card border border-line shadow-card',
        className,
      )}
      {...rest}
    />
  )
}
